export const weapontype = [
  { _id: 1, name: "무기" },
  { _id: 2, name: "엠블렘" },
  { _id: 3, name: "보조무기" },
  { _id: 4, name: "방패" },
  { _id: 5, name: "모자" },
];

export const weaponlevel = [
  { _id: 1, name: "200" },
  { _id: 2, name: "160" },
  { _id: 3, name: "150" },
  { _id: 4, name: "145" },
  { _id: 5, name: "140" },
];

export const optiontier = [
  { _id: 1, name: "레어" },
  { _id: 2, name: "에픽" },
  { _id: 3, name: "유니크" },
  { _id: 4, name: "레전드리" },
];

export const additionaloptiontier = [
  { _id: 1, name: "레어" },
  { _id: 2, name: "에픽" },
  { _id: 3, name: "유니크" },
  { _id: 4, name: "레전드리" },
];

export const redCubeFirstOption = [
  { weight: 9.7561, id: "STR+12%" },
  { weight: 9.7561, id: "DEX : +12%" },
  { weight: 9.7561, id: "INT : +12%" },
  { weight: 9.7561, id: "LUK : +12%" },
  { weight: 4.878, id: "공격력 : +12%" },
  { weight: 4.878, id: "마력 : +12%" },
  { weight: 4.878, id: "크리티컬 확률 : +12%" },
  { weight: 4.878, id: "데미지 : +12%" },
  { weight: 7.3171, id: "올스탯 : +9%" },
  { weight: 4.878, id: "캐릭터 기준 10레벨 당 공격력 : +1" },
  { weight: 4.878, id: "캐릭터 기준 10레벨 당 마력 : +1" },
  { weight: 4.878, id: "몬스터 방어율 무시 : +35%" },
  { weight: 4.878, id: "몬스터 방어율 무시 : +40%" },
  { weight: 4.878, id: "보스 몬스터 공격 시 데미지 : +30%" },
  { weight: 4.878, id: "보스 몬스터 공격 시 데미지 : +35%" },
  { weight: 4.878, id: "보스 몬스터 공격 시 데미지 : +40%" },
];

export const redCubeSecondOption = [
  { weight: 10.0, id: "STR : +9%" },
  { weight: 10.0, id: "DEX : +9%" },
  { weight: 10.0, id: "INT : +9%" },
  { weight: 10.0, id: "LUK : +9%" },
  { weight: 6.0, id: "공격력 : 9%" },
  { weight: 6.0, id: "마력 : +9%" },
  { weight: 8.0, id: "크리티컬 확률 : +9%" },
  { weight: 6.0, id: "데미지 : +9%" },
  { weight: 8.0, id: "올스탯 : +6%" },
  { weight: 6.0, id: "몬스터 방어율 무시 : +30%" },
  { weight: 6.0, id: "보스 몬스터 공격 시 데미지 : +20%" },
  { weight: 4.0, id: "보스 몬스터 공격 시 데미지 : +30%" },
  { weight: 0.976, id: "STR: +12%" },
  { weight: 0.976, id: "DEX : +12%" },
  { weight: 0.976, id: "INT : +12%" },
  { weight: 0.976, id: "LUK : +12%" },
  { weight: 0.488, id: "공격력 : +12%" },
  { weight: 0.488, id: "마력 : +12%" },
  { weight: 0.488, id: "크리티컬 확률 : +12%" },
  { weight: 0.488, id: "데미지 : +12%" },
  { weight: 0.732, id: "올스탯 : +9%" },
  { weight: 0.488, id: "캐릭터 기준 10레벨 당 공격력 : +1" },
  { weight: 0.488, id: "캐릭터 기준 10레벨 당 마력 : +1" },
  { weight: 0.488, id: "몬스터 방어율 무시 : +35%" },
  { weight: 0.488, id: "몬스터 방어율 무시 : +40%" },
  { weight: 0.488, id: "보스 몬스터 공격 시 데미지 : +30%" },
  { weight: 0.488, id: "보스 몬스터 공격 시 데미지 : +35%" },
  { weight: 0.488, id: "보스 몬스터 공격 시 데미지 : +40%" },
];

export const redCubeThirdOption = [
  { weight: 11.0, id: "STR : +9%" },
  { weight: 11.0, id: "DEX : +9%" },
  { weight: 11.0, id: "INT : +9%" },
  { weight: 11.0, id: "LUK : +9%" },
  { weight: 6.6, id: "공격력 : 9%" },
  { weight: 6.6, id: "마력 : +9%" },
  { weight: 8.8, id: "크리티컬 확률 : +9%" },
  { weight: 6.6, id: "데미지 : +9%" },
  { weight: 8.8, id: "올스탯 : +6%" },
  { weight: 6.6, id: "몬스터 방어율 무시 : +30%" },
  { weight: 6.6, id: "보스 몬스터 공격 시 데미지 : +20%" },
  { weight: 4.4, id: "보스 몬스터 공격 시 데미지 : +30%" },
  { weight: 0.976, id: "STR: +12%" },
  { weight: 0.976, id: "DEX : +12%" },
  { weight: 0.976, id: "INT : +12%" },
  { weight: 0.976, id: "LUK : +12%" },
  { weight: 0.488, id: "공격력 : +12%" },
  { weight: 0.488, id: "마력 : +12%" },
  { weight: 0.488, id: "크리티컬 확률 : +12%" },
  { weight: 0.488, id: "데미지 : +12%" },
  { weight: 0.732, id: "올스탯 : +9%" },
  { weight: 0.488, id: "캐릭터 기준 10레벨 당 공격력 : +1" },
  { weight: 0.488, id: "캐릭터 기준 10레벨 당 마력 : +1" },
  { weight: 0.488, id: "몬스터 방어율 무시 : +35%" },
  { weight: 0.488, id: "몬스터 방어율 무시 : +40%" },
  { weight: 0.488, id: "보스 몬스터 공격 시 데미지 : +30%" },
  { weight: 0.488, id: "보스 몬스터 공격 시 데미지 : +35%" },
  { weight: 0.488, id: "보스 몬스터 공격 시 데미지 : +40%" },
];

export const blackCubeFirstOption = [
  { weight: 9.7561, id: "STR+12%" },
  { weight: 9.7561, id: "DEX : +12%" },
  { weight: 9.7561, id: "INT : +12%" },
  { weight: 9.7561, id: "LUK : +12%" },
  { weight: 4.878, id: "공격력 : +12%" },
  { weight: 4.878, id: "마력 : +12%" },
  { weight: 4.878, id: "크리티컬 확률 : +12%" },
  { weight: 4.878, id: "데미지 : +12%" },
  { weight: 4.878, id: "올스탯 : +9%" },
  { weight: 4.878, id: "캐릭터 기준 10레벨 당 공격력 : +1" },
  { weight: 4.878, id: "캐릭터 기준 10레벨 당 마력 : +1" },
  { weight: 4.878, id: "몬스터 방어율 무시 : +35%" },
  { weight: 4.878, id: "몬스터 방어율 무시 : +40%" },
  { weight: 4.878, id: "보스 몬스터 공격 시 데미지 : +30%" },
  { weight: 4.878, id: "보스 몬스터 공격 시 데미지 : +35%" },
  { weight: 7.3171, id: "보스 몬스터 공격 시 데미지 : +40%" },
];

export const blackCubeSecondOption = [
  { weight: 10.0, id: "STR : +9%" },
  { weight: 10.0, id: "DEX : +9%" },
  { weight: 10.0, id: "INT : +9%" },
  { weight: 10.0, id: "LUK : +9%" },
  { weight: 6.0, id: "공격력 : 9%" },
  { weight: 6.0, id: "마력 : +9%" },
  { weight: 8.0, id: "크리티컬 확률 : +9%" },
  { weight: 6.0, id: "데미지 : +9%" },
  { weight: 8.0, id: "올스탯 : +6%" },
  { weight: 6.0, id: "몬스터 방어율 무시 : +30%" },
  { weight: 6.0, id: "보스 몬스터 공격 시 데미지 : +20%" },
  { weight: 4.0, id: "보스 몬스터 공격 시 데미지 : +30%" },
  { weight: 0.976, id: "STR: +12%" },
  { weight: 0.976, id: "DEX : +12%" },
  { weight: 0.976, id: "INT : +12%" },
  { weight: 0.976, id: "LUK : +12%" },
  { weight: 0.488, id: "공격력 : +12%" },
  { weight: 0.488, id: "마력 : +12%" },
  { weight: 0.488, id: "크리티컬 확률 : +12%" },
  { weight: 0.488, id: "데미지 : +12%" },
  { weight: 0.732, id: "올스탯 : +9%" },
  { weight: 0.488, id: "캐릭터 기준 10레벨 당 공격력 : +1" },
  { weight: 0.488, id: "캐릭터 기준 10레벨 당 마력 : +1" },
  { weight: 0.488, id: "몬스터 방어율 무시 : +35%" },
  { weight: 0.488, id: "몬스터 방어율 무시 : +40%" },
  { weight: 0.488, id: "보스 몬스터 공격 시 데미지 : +30%" },
  { weight: 0.488, id: "보스 몬스터 공격 시 데미지 : +35%" },
  { weight: 0.488, id: "보스 몬스터 공격 시 데미지 : +40%" },
];

export const blackCubeThirdOption = [
  { weight: 11.0, id: "STR : +9%" },
  { weight: 11.0, id: "DEX : +9%" },
  { weight: 11.0, id: "INT : +9%" },
  { weight: 11.0, id: "LUK : +9%" },
  { weight: 6.6, id: "공격력 : 9%" },
  { weight: 6.6, id: "마력 : +9%" },
  { weight: 8.8, id: "크리티컬 확률 : +9%" },
  { weight: 6.6, id: "데미지 : +9%" },
  { weight: 8.8, id: "올스탯 : +6%" },
  { weight: 6.6, id: "몬스터 방어율 무시 : +30%" },
  { weight: 6.6, id: "보스 몬스터 공격 시 데미지 : +20%" },
  { weight: 4.4, id: "보스 몬스터 공격 시 데미지 : +30%" },
  { weight: 0.976, id: "STR: +12%" },
  { weight: 0.976, id: "DEX : +12%" },
  { weight: 0.976, id: "INT : +12%" },
  { weight: 0.976, id: "LUK : +12%" },
  { weight: 0.488, id: "공격력 : +12%" },
  { weight: 0.488, id: "마력 : +12%" },
  { weight: 0.488, id: "크리티컬 확률 : +12%" },
  { weight: 0.488, id: "데미지 : +12%" },
  { weight: 0.732, id: "올스탯 : +9%" },
  { weight: 0.488, id: "캐릭터 기준 10레벨 당 공격력 : +1" },
  { weight: 0.488, id: "캐릭터 기준 10레벨 당 마력 : +1" },
  { weight: 0.488, id: "몬스터 방어율 무시 : +35%" },
  { weight: 0.488, id: "몬스터 방어율 무시 : +40%" },
  { weight: 0.488, id: "보스 몬스터 공격 시 데미지 : +30%" },
  { weight: 0.488, id: "보스 몬스터 공격 시 데미지 : +35%" },
  { weight: 0.488, id: "보스 몬스터 공격 시 데미지 : +40%" },
];

export const additionalCubeFirstOption = [
  { weight: 7.5, id: "최대 HP : +10%" },
  { weight: 7.5, id: "최대 MP : +10%" },
  { weight: 5.0, id: "공격력 : +12%" },
  { weight: 5.0, id: "마력 : +12%" },
  { weight: 5.0, id: "크리티컬 확률 : +12%" },
  { weight: 7.5, id: "STR : +12%" },
  { weight: 7.5, id: "DEX : +12%" },
  { weight: 7.5, id: "INT : +12%" },
  { weight: 7.5, id: "LUK : +12%" },
  { weight: 2.5, id: "데미지 : +12%" },
  { weight: 5.0, id: "올스탯 : +9%" },
  { weight: 5.0, id: "캐릭터 기준 10레벨 당 STR : +2" },
  { weight: 5.0, id: "캐릭터 기준 10레벨 당 DEX : +2" },
  { weight: 5.0, id: "캐릭터 기준 10레벨 당 INT : +2" },
  { weight: 5.0, id: "캐릭터 기준 10레벨 당 LUK : +2" },
  { weight: 2.5, id: "캐릭터 기준 10레벨 당 공격력 : +1" },
  { weight: 2.5, id: "캐릭터 기준 10레벨 당 마력 : +1" },
  { weight: 2.5, id: "상태 이상 내성 : +5" },
  { weight: 2.5, id: "몬스터 방어율 무시 : +5%" },
  { weight: 2.5, id: "보스 몬스터 공격 시 데미지 : +18%" },
];

export const additionalCubeSecondOption = [
  { weight: 6.94, id: "최대 HP : +7%" },
  { weight: 6.94, id: "최대 MP : +7%" },
  { weight: 4.63, id: "공격력 : +9%" },
  { weight: 4.63, id: "마력 : +9%" },
  { weight: 4.63, id: "크리티컬 확률 : +9%" },
  { weight: 6.94, id: "STR : +9%" },
  { weight: 6.94, id: "DEX : +9%" },
  { weight: 6.94, id: "INT : +9%" },
  { weight: 6.94, id: "LUK : +9%" },
  { weight: 2.31, id: "데미지 : +9%" },
  { weight: 4.63, id: "올스탯 : +6%" },
  { weight: 4.63, id: "캐릭터 기준 10레벨 당 STR : +1" },
  { weight: 4.63, id: "캐릭터 기준 10레벨 당 DEX : +1" },
  { weight: 4.63, id: "캐릭터 기준 10레벨 당 INT : +1" },
  { weight: 4.63, id: "캐릭터 기준 10레벨 당 LUK : +1" },
  { weight: 6.94, id: "공격 시 15% 확률로 95의 HP 회복" },
  { weight: 6.94, id: "공격 시 15% 확률로 95의 MP 회복" },
  { weight: 2.31, id: "몬스터 방어율 무시 : +4%" },
  { weight: 2.31, id: "보스 몬스터 공격 시 데미지 : +12%" },
  { weight: 0.04, id: "최대 HP : +10%" },
  { weight: 0.04, id: "최대 MP : +10%" },
  { weight: 0.02, id: "공격력 : +12%" },
  { weight: 0.02, id: "마력 : +12%" },
  { weight: 0.02, id: "크리티컬 확률 : +12%" },
  { weight: 0.04, id: "STR : +12%" },
  { weight: 0.04, id: "DEX : +12%" },
  { weight: 0.04, id: "INT : +12%" },
  { weight: 0.04, id: "LUK : +12%" },
  { weight: 0.01, id: "데미지 : +12%" },
  { weight: 0.02, id: "올스탯 : +9%" },
  { weight: 0.02, id: "캐릭터 기준 10레벨 당 STR : +2" },
  { weight: 0.02, id: "캐릭터 기준 10레벨 당 DEX : +2" },
  { weight: 0.02, id: "캐릭터 기준 10레벨 당 INT : +2" },
  { weight: 0.02, id: "캐릭터 기준 10레벨 당 LUK : +2" },
  { weight: 0.01, id: "캐릭터 기준 10레벨 당 공격력 : +1" },
  { weight: 0.01, id: "캐릭터 기준 10레벨 당 마력 : +1" },
  { weight: 0.01, id: "상태 이상 내성 : +5" },
  { weight: 0.01, id: "몬스터 방어율 무시 : +5%" },
  { weight: 0.01, id: "보스 몬스터 공격 시 데미지 : +18%" },
];

export const additionalCubeThirdOption = [
  { weight: 6.94, id: "최대 HP : +7%" },
  { weight: 6.94, id: "최대 MP : +7%" },
  { weight: 4.63, id: "공격력 : +9%" },
  { weight: 4.63, id: "마력 : +9%" },
  { weight: 4.63, id: "크리티컬 확률 : +9%" },
  { weight: 6.94, id: "STR : +9%" },
  { weight: 6.94, id: "DEX : +9%" },
  { weight: 6.94, id: "INT : +9%" },
  { weight: 6.94, id: "LUK : +9%" },
  { weight: 2.31, id: "데미지 : +9%" },
  { weight: 4.63, id: "올스탯 : +6%" },
  { weight: 4.63, id: "캐릭터 기준 10레벨 당 STR : +1" },
  { weight: 4.63, id: "캐릭터 기준 10레벨 당 DEX : +1" },
  { weight: 4.63, id: "캐릭터 기준 10레벨 당 INT : +1" },
  { weight: 4.63, id: "캐릭터 기준 10레벨 당 LUK : +1" },
  { weight: 6.94, id: "공격 시 15% 확률로 95의 HP 회복" },
  { weight: 6.94, id: "공격 시 15% 확률로 95의 MP 회복" },
  { weight: 2.31, id: "몬스터 방어율 무시 : +4%" },
  { weight: 2.31, id: "보스 몬스터 공격 시 데미지 : +12%" },
  { weight: 0.04, id: "최대 HP : +10%" },
  { weight: 0.04, id: "최대 MP : +10%" },
  { weight: 0.02, id: "공격력 : +12%" },
  { weight: 0.02, id: "마력 : +12%" },
  { weight: 0.02, id: "크리티컬 확률 : +12%" },
  { weight: 0.04, id: "STR : +12%" },
  { weight: 0.04, id: "DEX : +12%" },
  { weight: 0.04, id: "INT : +12%" },
  { weight: 0.04, id: "LUK : +12%" },
  { weight: 0.01, id: "데미지 : +12%" },
  { weight: 0.02, id: "올스탯 : +9%" },
  { weight: 0.02, id: "캐릭터 기준 10레벨 당 STR : +2" },
  { weight: 0.02, id: "캐릭터 기준 10레벨 당 DEX : +2" },
  { weight: 0.02, id: "캐릭터 기준 10레벨 당 INT : +2" },
  { weight: 0.02, id: "캐릭터 기준 10레벨 당 LUK : +2" },
  { weight: 0.01, id: "캐릭터 기준 10레벨 당 공격력 : +1" },
  { weight: 0.01, id: "캐릭터 기준 10레벨 당 마력 : +1" },
  { weight: 0.01, id: "상태 이상 내성 : +5" },
  { weight: 0.01, id: "몬스터 방어율 무시 : +5%" },
  { weight: 0.01, id: "보스 몬스터 공격 시 데미지 : +18%" },
];

export const redcubeRareToEpic = [
  { weight: 94, _id: 0 },
  { weight: 6, _id: 1 },
];
export const redcubeEpictoUnique = [
  { weight: 98.2, _id: 0 },
  { weight: 1.8, _id: 1 },
];
export const redcubeUniquetoLegendary = [
  { weight: 99.7, _id: 0 },
  { weight: 0.3, _id: 1 },
];

export const blackcubeRareToEpic = [
  { weight: 85, _id: 0 },
  { weight: 15, _id: 1 },
];
export const blackcubeEpictoUnique = [
  { weight: 96.5, _id: 0 },
  { weight: 3.5, _id: 1 },
];
export const blackcubeUniquetoLegendary = [
  { weight: 99, _id: 0 },
  { weight: 1, _id: 1 },
];

export const additionalcubeRareToEpic = [
  { weight: 95.3, _id: 0 },
  { weight: 4.7, _id: 1 },
];
export const additionalcubeEpictoUnique = [
  { weight: 98, _id: 0 },
  { weight: 2, _id: 1 },
];
export const additionalcubeUniquetoLegendary = [
  { weight: 99.5, _id: 0 },
  { weight: 0.5, _id: 1 },
];
